module.exports = __webpack_public_path__ + "static/media/hand-drag.98e27b3e.svg";